(function () {
    'use strict';

    angular
        .module('appback')
        .controller('ShiftsController', ShiftsController);

    ShiftsController.$inject = ["ShiftsService", "$q", "$scope"];

    function ShiftsController(ShiftsService, $q, $scope) {

        var vm = this;

        // Textos traducibles: la clave es el texto en inglés y la traducción
        // llega de showcalendar.twig (window.shiftsI18n, generado con t.getTraduction).
        // {nombre} se sustituye por params.nombre.
        function tr(text, params) {
            var dict = window.shiftsI18n || {};
            var result = dict[text] || text;
            angular.forEach(params || {}, function (value, key) {
                result = result.split('{' + key + '}').join(value);
            });
            return result;
        }

        vm.tr = tr;

        var now = new Date();

        vm.monthNames = [
            tr('January'), tr('February'), tr('March'), tr('April'), tr('May'), tr('June'),
            tr('July'), tr('August'), tr('September'), tr('October'), tr('November'), tr('December')
        ];

        vm.filters = {
            month: now.getMonth() + 1,
            year: now.getFullYear(),
            // Selección múltiple: listas de ids ('none' en distintivos = sin distintivo).
            departments: [],
            shiftType: null,
            search: '',
            distinguishers: []
        };

        vm.departments = [];
        vm.shiftTypes = [];
        vm.productionLines = [];
        vm.personalList = [];
        vm.rows = [];
        vm.days = [];
        vm.daysInMonth = 0;
        vm.loading = false;

        // Datos de cada día de la rejilla (letra, domingo, hoy), calculados al
        // cargarla en vez de en cada ciclo de render (ver vm.buildDayMeta).
        vm.dayMeta = {};

        // Total de horas y nº de turnos por código de la página cargada,
        // recalculados solo cuando cambian las filas (ver vm.refreshGridSummary).
        vm.gridSummary = { totalHours: 0, countByCode: {} };

        // Cada carga de la rejilla tiene un número; si llega la respuesta de
        // una carga anterior (p. ej. al cambiar rápido de mes o de búsqueda),
        // se descarta para no pisar a la más reciente.
        var gridRequestId = 0;

        // El personal se pagina en el backend para no construir la rejilla
        // de turnos de todo el mundo en cada carga.
        vm.gridPage = 1;
        vm.gridPageSize = 15;
        vm.gridTotal = 0;
        vm.gridTotalPages = 1;

        vm.isEditorOpen = false;
        vm.editorRow = null;
        vm.editorDay = null;

        // Popup de avisos (modals/_popup.twig). type: 'error' | 'success'.
        // "detail" es el mensaje que devuelva el servidor, si lo hay.
        vm.popup = {
            open: false,
            type: 'error',
            message: '',
            detail: ''
        };

        vm.showError = function (message, error) {

            var detail = '';

            if (error) {
                if (error.data && error.data.message) {
                    detail = error.data.message;
                } else if (error.message) {
                    detail = error.message;
                } else if (angular.isString(error)) {
                    detail = error;
                }
            }

            vm.popup = {
                open: true,
                type: 'error',
                message: message,
                detail: detail !== message ? detail : ''
            };
        };

        // items: lista opcional de avisos que se muestra bajo el mensaje.
        vm.showSuccess = function (message, items) {
            vm.popup = {
                open: true,
                type: 'success',
                message: message,
                detail: '',
                items: items || []
            };
        };

        vm.closePopup = function () {
            vm.popup.open = false;
        };

        // Popup de confirmación (modals/_popup.twig), en lugar de confirm().
        // onConfirm se ejecuta solo si el usuario pulsa el botón de confirmar.
        vm.confirmPopup = {
            open: false,
            title: '',
            message: '',
            confirmLabel: '',
            onConfirm: null
        };

        vm.askConfirm = function (options) {
            vm.confirmPopup = {
                open: true,
                title: options.title,
                message: options.message,
                confirmLabel: options.confirmLabel || tr('Accept'),
                onConfirm: options.onConfirm
            };
        };

        vm.closeConfirmPopup = function () {
            vm.confirmPopup.open = false;
            vm.confirmPopup.onConfirm = null;
        };

        vm.acceptConfirmPopup = function () {

            var onConfirm = vm.confirmPopup.onConfirm;

            vm.closeConfirmPopup();

            if (onConfirm) {
                onConfirm();
            }
        };

        // Errores de validación por campo (clave => mensaje). Las vistas
        // marcan en rojo los campos que aparecen aquí.
        vm.fieldErrors = {};

        vm.setFieldErrors = function (errors) {
            vm.fieldErrors = errors;

            return Object.keys(errors).length === 0;
        };

        vm.clearFieldError = function (key) {
            delete vm.fieldErrors[key];
        };

        vm.resetFieldErrors = function () {
            vm.fieldErrors = {};
        };

        // Un patrón de días válido es un entero de al menos 1.
        vm.isValidPatternDays = function (value) {
            var number = Number(value);

            return !!value && Math.floor(number) === number && number >= 1;
        };

        // Departamento que se deja filtrado al abrir el calendario.
        vm.defaultDepartmentName = '22 - PRODUCCION';

        // Compara nombres sin tener en cuenta mayúsculas, tildes, espacios ni
        // guiones ("22 - PRODUCCION" = "22-Producción").
        vm.normalizeDepartmentName = function (name) {
            return String(name || '')
                .normalize('NFD').replace(/[̀-ͯ]/g, '')
                .toLowerCase()
                .replace(/[^a-z0-9]/g, '');
        };

        vm.init = function () {

            // La rejilla se carga cuando ya se conoce el departamento por
            // defecto, para no pedirla dos veces (sin filtro y con filtro).
            ShiftsService.GetDepartments().then(function (data) {

                if (data && data.success) {
                    vm.departments = data.departments || [];
                }

                var target = vm.normalizeDepartmentName(vm.defaultDepartmentName);

                var defaultDepartment = vm.departments.filter(function (department) {
                    return vm.normalizeDepartmentName(department.name) === target;
                })[0];

                if (defaultDepartment) {
                    vm.filters.departments = [String(defaultDepartment.id)];
                }

            }).finally(function () {

                vm.loadFilterDistinguishers();

                vm.departmentsReady = true;

                // Abierto desde el kanban (?view=workorders): la rejilla de
                // turnos se carga al cambiar a ella (vm.setView).
                if (vm.view === 'shifts') {
                    vm.loadGrid(1);
                }
            });

            ShiftsService.GetShiftTypes().then(function (data) {
                if (data && data.success) {
                    vm.shiftTypes = data.shiftTypes || [];
                }
            });

            ShiftsService.GetProductionLines().then(function (data) {
                if (data && data.success) {
                    vm.productionLines = data.productionLines || [];
                }
            });

            ShiftsService.GetPersonal().then(function (data) {
                if (data && data.success) {
                    vm.personalList = data.personal || [];
                }
            });
        };

        vm.buildDaysArray = function (daysInMonth) {

            var days = [];

            for (var i = 1; i <= daysInMonth; i++) {
                days.push(i);
            }

            return days;
        };

        vm.buildGridParams = function (page) {

            var params = {
                month: vm.filters.month,
                year: vm.filters.year,
                page: page,
                pageSize: vm.gridPageSize
            };

            if (vm.filters.departments.length) {
                params.department = vm.filters.departments.join(',');
            }

            if (vm.filters.shiftType) {
                params.shiftType = vm.filters.shiftType;
            }

            if (vm.filters.search) {
                params.search = vm.filters.search;
            }

            if (vm.filters.groupByDistinguisher) {
                params.groupBy = 'distinguisher';
            }

            if (vm.filters.distinguishers.length) {
                params.distinguisher = vm.filters.distinguishers.join(',');
            }

            return params;
        };

        // Carga una página de operarios. Sin página se recarga la actual
        // (p. ej. tras generar/borrar el mes o cerrar el modal individual).
        vm.loadGrid = function (page) {

            page = page || vm.gridPage || 1;

            var requestId = ++gridRequestId;

            vm.loading = true;
            vm.gridLoaded = true;

            return ShiftsService.GetGrid(vm.buildGridParams(page)).then(function (data) {

                // Ya se ha pedido otra carga después de esta.
                if (requestId !== gridRequestId) {
                    return;
                }

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                var totalPages = data.totalPages || 1;

                // Si la página pedida ya no existe (han desaparecido operarios
                // con los filtros actuales), se carga la última que sí existe.
                if (page > totalPages && page > 1) {
                    return vm.loadGrid(totalPages);
                }

                vm.rows = data.rows || [];
                vm.rows.forEach(vm.decorateRowCells);
                vm.daysInMonth = data.daysInMonth;
                vm.days = vm.buildDaysArray(data.daysInMonth);
                vm.dayMeta = vm.buildDayMeta(data.year, data.month, data.daysInMonth);
                vm.gridPage = data.page || page;
                vm.gridTotal = data.total || 0;
                vm.gridTotalPages = totalPages;

                vm.refreshGridSummary();

            }).catch(function (error) {

                if (requestId === gridRequestId) {
                    vm.showError(tr('Could not get the shifts calendar.'), error);
                }

            }).finally(function () {

                if (requestId === gridRequestId) {
                    vm.loading = false;
                }
            });
        };

        // Letra del día de la semana, si es domingo y si es hoy, para cada día
        // del mes: la cabecera y las celdas de la rejilla los leen de aquí.
        vm.buildDayMeta = function (year, month, daysInMonth) {

            var letters = [tr('Su'), tr('Mo'), tr('Tu'), tr('We'), tr('Th'), tr('Fr'), tr('Sa')];
            var today = new Date();
            var isCurrentMonth = Number(year) === today.getFullYear() && Number(month) === today.getMonth() + 1;
            var meta = {};

            for (var day = 1; day <= daysInMonth; day++) {

                var weekDay = new Date(year, month - 1, day).getDay();

                meta[day] = {
                    letter: letters[weekDay],
                    isSunday: weekDay === 0,
                    isToday: isCurrentMonth && day === today.getDate()
                };
            }

            return meta;
        };

        vm.refreshGridSummary = function () {

            var summary = { totalHours: 0, countByCode: {} };

            vm.rows.forEach(function (row) {

                summary.totalHours += Number(row.hours) || 0;

                vm.days.forEach(function (day) {

                    var cell = row.shifts[day];

                    if (cell && cell.code) {
                        summary.countByCode[cell.code] = (summary.countByCode[cell.code] || 0) + 1;
                    }
                });
            });

            vm.gridSummary = summary;
        };

        vm.gridPageSizeOptions = [15, 25, 50, 100];

        vm.goToPage = function (page) {

            if (vm.loading || page < 1 || page > vm.gridTotalPages || page === vm.gridPage) {
                return;
            }

            vm.loadGrid(page);
        };

        vm.changePageSize = function () {
            vm.loadGrid(1);
        };

        // Números de página a mostrar: la primera, la última y las cercanas
        // a la actual; los huecos se marcan con null ("...").
        vm.getPageNumbers = function () {

            var total = vm.gridTotalPages;
            var current = vm.gridPage;
            var pages = [];

            for (var i = 1; i <= total; i++) {
                if (i === 1 || i === total || Math.abs(i - current) <= 2) {
                    pages.push(i);
                } else if (pages[pages.length - 1] !== null) {
                    pages.push(null);
                }
            }

            return pages;
        };

        vm.getRowOffset = function () {
            return (vm.gridPage - 1) * vm.gridPageSize;
        };

        vm.changeMonth = function (delta) {

            var date = new Date(vm.filters.year, vm.filters.month - 1 + delta, 1);

            vm.filters.month = date.getMonth() + 1;
            vm.filters.year = date.getFullYear();

            vm.loadGrid(1);
        };

        // Pestaña visible: 'shifts' (turnos) | 'workorders' (órdenes de trabajo).
        // El calendario de OTs tiene su propio controlador (y su propio mes):
        // WorkOrdersCalendarController. Aquí solo se decide qué pestaña se ve.
        // El kanban enlaza con ?view=workorders para abrir directamente las OTs.
        vm.view = /[?&]view=workorders(&|$)/.test(window.location.search) ? 'workorders' : 'shifts';

        // El calendario de OTs se crea la primera vez que se abre su pestaña
        // y se conserva después (con su mes y filtros) al cambiar de pestaña.
        vm.workOrdersOpened = vm.view === 'workorders';

        // Si se abrió en la pestaña de OTs, la rejilla de turnos no se ha
        // cargado todavía: se carga la primera vez que se abre su pestaña.
        vm.gridLoaded = false;
        vm.departmentsReady = false;

        vm.setView = function (view) {

            vm.view = view;

            if (view === 'workorders') {
                vm.workOrdersOpened = true;
            } else if (!vm.gridLoaded && vm.departmentsReady) {
                vm.loadGrid(1);
            }
        };

        vm.applyFilters = function () {
            vm.loadGrid(1);
        };

        // Distintivos del filtro de la barra (los del departamento seleccionado,
        // más los que no tienen departamento). Distinto de vm.distinguishers,
        // que es la lista del modal individual (la del departamento de la persona).
        vm.filterDistinguishers = [];

        vm.loadFilterDistinguishers = function () {

            var params = {};

            if (vm.filters.departments.length) {
                params.department = vm.filters.departments.join(',');
            }

            return ShiftsService.GetDistinguishers(params).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.filterDistinguishers = data.distinguishers || [];

                // Se quitan de la selección los distintivos que ya no son de
                // ninguno de los departamentos elegidos ('none' se conserva).
                vm.filters.distinguishers = vm.filters.distinguishers.filter(function (selected) {
                    return selected === 'none' || vm.filterDistinguishers.some(function (distinguisher) {
                        return String(distinguisher.id) === String(selected);
                    });
                });

            }).catch(function (error) {

                vm.showError(tr('Could not get the areas.'), error);
            });
        };

        vm.onDepartmentChange = function () {
            vm.loadFilterDistinguishers().finally(vm.applyFilters);
        };

        // Desplegables de selección múltiple de la barra ('department' o
        // 'distinguisher'); solo uno abierto a la vez.
        vm.openFilterDropdown = null;

        vm.toggleFilterDropdown = function (name) {
            vm.openFilterDropdown = vm.openFilterDropdown === name ? null : name;
        };

        vm.closeFilterDropdowns = function () {
            vm.openFilterDropdown = null;
        };

        vm.isFilterSelected = function (list, id) {
            return list.indexOf(String(id)) !== -1;
        };

        // Añade o quita un id de una lista de selección (los ids se guardan como texto).
        vm.toggleFilterValue = function (list, id) {

            var index = list.indexOf(String(id));

            if (index === -1) {
                list.push(String(id));
            } else {
                list.splice(index, 1);
            }
        };

        vm.toggleDepartmentFilter = function (id) {
            vm.toggleFilterValue(vm.filters.departments, id);
            vm.onDepartmentChange();
        };

        vm.clearDepartmentFilter = function () {
            vm.filters.departments = [];
            vm.onDepartmentChange();
        };

        vm.toggleDistinguisherFilter = function (id) {
            vm.toggleFilterValue(vm.filters.distinguishers, id);
            vm.applyFilters();
        };

        vm.clearDistinguisherFilter = function () {
            vm.filters.distinguishers = [];
            vm.applyFilters();
        };

        // Texto del botón: "Todos", el nombre si hay uno, o "N seleccionados".
        vm.getMultiFilterLabel = function (selectedIds, options, noneLabel) {

            if (!selectedIds.length) {
                return tr('All');
            }

            if (selectedIds.length > 1) {
                return tr('{count} selected', { count: selectedIds.length });
            }

            if (selectedIds[0] === 'none') {
                return noneLabel;
            }

            var option = (options || []).find(function (item) {
                return String(item.id) === selectedIds[0];
            });

            return option ? option.name : tr('1 selected');
        };

        // Alterna entre el orden normal (apellidos/nombre) y agrupar por distintivo.
        vm.toggleGroupByDistinguisher = function () {
            vm.filters.groupByDistinguisher = !vm.filters.groupByDistinguisher;
            vm.applyFilters();
        };

        vm.getCellStyle = function (row, day) {

            var cell = row.shifts[day];

            if (cell && cell.color) {
                return {
                    'background-color': '#' + cell.color + '26',
                    'border-color': '#' + cell.color,
                    'color': '#000000'
                };
            }

            return {};
        };

        vm.pendingShiftType = null;

        vm.pendingReasonShiftType = null;
        vm.pendingReason = '';
        vm.pendingReasonInfo = '';
        // Rango de fechas (Date) de los tipos de turno con "have_range"; se
        // eligen con un datepicker y pueden abarcar varios meses.
        vm.pendingRangeStart = null;
        vm.pendingRangeEnd = null;

        // Fecha (Date) de un día del mes que se está editando.
        vm.getEditorDayDate = function (day) {
            return new Date(vm.editorYear, vm.editorMonth - 1, day);
        };

        vm.formatDayString = function (date) {
            return date.getFullYear() + '-' +
                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                String(date.getDate()).padStart(2, '0');
        };

        vm.openShiftEditor = function (row, day, month, year, context) {

            vm.editorRow = row;
            vm.editorDay = day;
            vm.editorMonth = month || vm.filters.month;
            vm.editorYear = year || vm.filters.year;
            vm.editorContext = context || 'general';
            vm.pendingShiftType = null;
            vm.pendingNextShiftType = vm.pendingFirstDayLine = null;
            vm.pendingReasonShiftType = null;
            vm.pendingReason = '';
            vm.pendingReasonInfo = '';
            vm.pendingRangeStart = vm.getEditorDayDate(day);
            vm.pendingRangeEnd = vm.getEditorDayDate(day);
            vm.resetFieldErrors();
            vm.isEditorOpen = true;
        };

        vm.closeShiftEditor = function () {

            vm.isEditorOpen = false;
            vm.editorRow = null;
            vm.editorDay = null;
            vm.pendingShiftType = null;
            vm.pendingNextShiftType = vm.pendingFirstDayLine = null;
            vm.pendingReasonShiftType = null;
            vm.resetFieldErrors();
        };

        // Un tipo de turno "tiene horas" cuando tiene hora de inicio y de fin;
        // el backend manda en "hours" las horas de esa jornada.
        vm.isHourCode = function (shiftType) {
            return !!shiftType && Number(shiftType.hours) > 0;
        };

        vm.needsReason = function (shiftType) {
            return !!shiftType && !!shiftType.justification;
        };

        vm.needsRange = function (shiftType) {
            return !!shiftType && !!shiftType.have_range;
        };

        vm.selectShiftType = function (shiftType) {

            vm.resetFieldErrors();

            if (!shiftType) {
                return vm.saveShiftSelection(null, null, null);
            }

            // Las horas no se piden: el backend las calcula a partir de la
            // jornada laboral. "Primer día" no tiene jornada propia y recoge la
            // del turno (Turno 1 o 2) que se elija a continuación.
            if (shiftType.is_first_day) {
                vm.pendingShiftType = shiftType;
                vm.pendingNextShiftType = vm.pendingFirstDayLine = null;
                return;
            }

            if (vm.needsReason(shiftType) || vm.needsRange(shiftType)) {
                vm.pendingReasonShiftType = shiftType;
                vm.pendingReason = '';
                vm.pendingReasonInfo = '';
                vm.pendingRangeStart = vm.getEditorDayDate(vm.editorDay);
                vm.pendingRangeEnd = vm.getEditorDayDate(vm.editorDay);
                return;
            }

            return vm.saveShiftSelection(shiftType, null, null);
        };

        // "Primer día" recoge las horas y la jornada (inicio y fin) del turno
        // elegido (Turno 1 o 2). Solo se guarda "Primer día": la generación
        // automática del mes mira esas horas para saber con qué turno sigue.
        vm.selectPendingNextShiftType = function (shiftType) {
            vm.pendingNextShiftType = shiftType;

            vm.clearFieldError('pendingNextShiftType');
        };

        // "Primer día" también pide la línea en la que trabaja (id de ProductionLinel).
        vm.pendingFirstDayLine = null;

        vm.selectPendingFirstDayLine = function (line) {
            vm.pendingFirstDayLine = line;

            vm.clearFieldError('pendingFirstDayLine');
        };

        vm.isPendingFirstDayLine = function (line) {
            return !!vm.pendingFirstDayLine && !!line && String(vm.pendingFirstDayLine.id) === String(line.id);
        };

        vm.getFirstDayLineOptionStyle = function (line) {

            var selected = vm.isPendingFirstDayLine(line);

            return {
                'border-color': selected ? '#0284c7' : '#cbd5e1',
                'background-color': selected ? '#e0f2fe' : '#ffffff',
                'color': selected ? '#075985' : '#334155',
                'box-shadow': selected ? '0 0 0 2px #0ea5e9' : 'none'
            };
        };

        vm.isPendingNextShiftType = function (shiftType) {
            return !!vm.pendingNextShiftType && !!shiftType && String(vm.pendingNextShiftType.id) === String(shiftType.id);
        };

        // Estilo de cada opción de "¿De qué turno recoge las horas?". Turno 1 y
        // Turno 2 se ven iguales (blancos, sin el color de su tipo de turno);
        // la elegida se marca con el azul de la marca.
        vm.getFollowUpOptionStyle = function (shiftType) {

            var selected = vm.isPendingNextShiftType(shiftType);

            return {
                'border-color': selected ? '#0284c7' : '#cbd5e1',
                'background-color': selected ? '#e0f2fe' : '#ffffff',
                'color': selected ? '#075985' : '#334155',
                'box-shadow': selected ? '0 0 0 2px #0ea5e9' : 'none'
            };
        };

        vm.confirmPendingHours = function () {

            var shiftType = vm.pendingShiftType;

            if (!vm.editorRow || !vm.editorDay) {
                return;
            }

            var isFirstDay = !!(shiftType && shiftType.is_first_day);

            if (isFirstDay) {

                var errors = {};

                if (!vm.pendingNextShiftType) {
                    errors['pendingNextShiftType'] = tr('You must specify which shift "First day" takes its hours from.');
                }

                if (!vm.pendingFirstDayLine) {
                    errors['pendingFirstDayLine'] = tr('You must specify which line the worker works on.');
                }

                vm.fieldErrors = errors;

                if (Object.keys(errors).length) {
                    return;
                }
            }

            var hoursFromShiftType = isFirstDay ? vm.pendingNextShiftType : null;
            var line = isFirstDay ? vm.pendingFirstDayLine : null;

            return vm.saveOneShift(vm.editorRow, vm.editorDay, shiftType, null, null, hoursFromShiftType, line).then(function () {

                vm.finishShiftEdit();

            }).catch(function (error) {

                vm.showError(tr('Could not save the shift.'), error);
            });
        };

        vm.cancelPendingShiftType = function () {
            vm.pendingShiftType = null;
            vm.pendingNextShiftType = vm.pendingFirstDayLine = null;
            vm.resetFieldErrors();
        };

        vm.confirmPendingReason = function () {

            var shiftType = vm.pendingReasonShiftType;
            var errors = {};

            if (vm.needsReason(shiftType) && (!vm.pendingReason || !vm.pendingReason.trim())) {
                errors['pendingReason'] = tr('A reason is required.');
            }

            if (vm.needsRange(shiftType)) {

                var start = vm.pendingRangeStart;
                var end = vm.pendingRangeEnd;

                if (!(start instanceof Date) || isNaN(start.getTime())) {
                    errors['pendingRangeStart'] = tr('Enter a valid date.');
                }

                if (!(end instanceof Date) || isNaN(end.getTime())) {
                    errors['pendingRangeEnd'] = tr('Enter a valid date.');
                }

                if (!errors['pendingRangeStart'] && !errors['pendingRangeEnd'] && start > end) {
                    errors['pendingRangeEnd'] = tr('Must be on or after the start date.');
                }
            }

            if (!vm.setFieldErrors(errors)) {
                return;
            }

            var reason = vm.needsReason(shiftType) ? vm.pendingReason.trim() : null;
            var info = vm.needsReason(shiftType) ? vm.pendingReasonInfo : null;

            if (vm.needsRange(shiftType)) {
                return vm.saveShiftRange(shiftType, start, end, reason, info);
            }

            return vm.saveShiftSelection(shiftType, reason, info);
        };

        vm.cancelPendingReason = function () {
            vm.pendingReasonShiftType = null;
            vm.resetFieldErrors();
        };

        vm.saveOneShift = function (row, day, shiftType, reason, info, hoursFromShiftType, line) {
            return vm.saveShiftOnDate(row, vm.getEditorDayDate(day), shiftType, reason, info, hoursFromShiftType, line);
        };

        // Guarda el turno de una fecha cualquiera; solo se refleja en la fila
        // si la fecha cae en el mes que se está mostrando. Las horas las
        // calcula el backend a partir de la jornada; "hoursFromShiftType" es
        // el tipo de turno del que se recoge la jornada y "line" la línea en
        // la que trabaja (los dos solo para "Primer día"; al resto de turnos
        // con horas el backend les pone la línea de su último turno).
        vm.saveShiftOnDate = function (row, date, shiftType, reason, info, hoursFromShiftType, line) {

            var isEditorMonth = date.getFullYear() === Number(vm.editorYear) &&
                date.getMonth() + 1 === Number(vm.editorMonth);
            var day = date.getDate();

            var payload = {
                personal: row.id,
                day: vm.formatDayString(date),
                shiftType: shiftType ? shiftType.id : null,
                reason: reason,
                info: info,
                hoursFrom: hoursFromShiftType ? hoursFromShiftType.id : null,
                line: line ? line.id : null
            };

            return ShiftsService.SaveShift(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                if (!isEditorMonth) {
                    return data;
                }

                var days = vm.isWorkerModalOpen ? vm.workerModalDays : vm.days;

                vm.applySavedShift(row, day, data.shift, days);

                return data;
            });
        };

        // Refleja en la fila un turno recién guardado (o borrado, con shift
        // null) y recalcula sus horas y el resumen de la rejilla.
        vm.applySavedShift = function (row, day, shift, days) {

            if (shift) {
                row.shifts[day] = vm.decorateCell(shift);
                row.hasAnyShift = true;
            } else {
                delete row.shifts[day];
            }

            row.hours = vm.recalculateRowHours(row, days);

            vm.refreshGridSummary();
        };

        // En el calendario individual el editor vive siempre en la columna
        // lateral (no es un modal emergente), así que al terminar de guardar no
        // se cierra: solo se limpian las selecciones pendientes para poder
        // seguir asignando turnos sobre el mismo día.
        vm.finishShiftEdit = function () {

            if (vm.isWorkerModalOpen && vm.editorContext === 'personal') {
                vm.pendingShiftType = null;
                vm.pendingNextShiftType = vm.pendingFirstDayLine = null;
                vm.pendingReasonShiftType = null;
                vm.resetFieldErrors();
                return;
            }

            vm.closeShiftEditor();
        };

        vm.saveShiftSelection = function (shiftType, reason, info) {

            if (!vm.editorRow || !vm.editorDay) {
                return;
            }

            return vm.saveOneShift(vm.editorRow, vm.editorDay, shiftType, reason, info).then(function () {

                vm.finishShiftEdit();

            }).catch(function (error) {

                vm.showError(tr('Could not save the shift.'), error);

            });
        };

        // Todo el rango se guarda en una sola petición (y transacción): o se
        // guardan todos los días o ninguno. Solo se reflejan en la fila los
        // días que caen en el mes que se está mostrando.
        vm.saveShiftRange = function (shiftType, startDate, endDate, reason, info) {

            if (!vm.editorRow) {
                return;
            }

            var row = vm.editorRow;

            var payload = {
                personal: row.id,
                shiftType: shiftType.id,
                start: vm.formatDayString(startDate),
                end: vm.formatDayString(endDate),
                reason: reason,
                info: info
            };

            return ShiftsService.SaveShiftRange(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                var monthPrefix = vm.formatDayString(new Date(Number(vm.editorYear), Number(vm.editorMonth) - 1, 1)).substr(0, 8);
                var days = vm.isWorkerModalOpen ? vm.workerModalDays : vm.days;

                angular.forEach(data.shifts || {}, function (shift, date) {
                    if (date.substr(0, 8) === monthPrefix) {
                        vm.applySavedShift(row, Number(date.substr(8, 2)), shift, days);
                    }
                });

                vm.finishShiftEdit();

            }).catch(function (error) {

                vm.showError(tr('Could not save the shift range.'), error);
            });
        };

        vm.recalculateRowHours = function (row, days) {

            return (days || vm.days).reduce(function (total, day) {

                var cell = row.shifts[day];

                // workedHours (del backend) ya descuenta los tipos sin horas.
                var hours = cell ? (cell.workedHours !== undefined ? cell.workedHours : cell.hours) : 0;

                return total + (Number(hours) || 0);

            }, 0);
        };

        vm.getWeekdayLetter = function (day) {

            var letters = [tr('Su'), tr('Mo'), tr('Tu'), tr('We'), tr('Th'), tr('Fr'), tr('Sa')];
            var date = new Date(vm.filters.year, vm.filters.month - 1, day);

            return letters[date.getDay()];
        };

        vm.isSunday = function (day) {

            var date = new Date(vm.filters.year, vm.filters.month - 1, day);

            return date.getDay() === 0;
        };

        vm.isToday = function (day) {

            var now = new Date();

            return day === now.getDate() &&
                vm.filters.month === (now.getMonth() + 1) &&
                vm.filters.year === now.getFullYear();
        };

        vm.getTotalHours = function () {
            return vm.gridSummary.totalHours.toFixed(2);
        };

        vm.getShiftTypeCount = function (shiftTypeCode) {
            return vm.gridSummary.countByCode[shiftTypeCode] || 0;
        };

        vm.getOtherShiftTypes = function () {

            return vm.shiftTypes.filter(function (type) {
                return !!type.justification;
            });
        };

        vm.getFollowUpShiftTypes = function () {

            return vm.shiftTypes.filter(function (type) {
                return !!type.is_turno_1 || !!type.is_turno_2;
            });
        };

        vm.getHourShiftTypes = function () {

            return vm.shiftTypes.filter(function (type) {
                return vm.isHourCode(type);
            });
        };

        vm.getNoWorkingDayShiftTypes = function () {

            return vm.shiftTypes.filter(function (type) {
                return !type.justification && !vm.isHourCode(type);
            });
        };

        vm.getEditorShiftTypes = function () {

            if (vm.editorContext === 'personal') {

                var hasAnyShift = !!(vm.editorRow && vm.editorRow.hasAnyShift);

                // Sin ningún turno anterior, solo se puede empezar por "Primer
                // día": el resto de tipos se ocultan hasta que se asigne uno.
                // En cuanto la persona tiene algún turno, "Primer día" ya no
                // puede volver a asignarse y desaparece de la lista.
                return vm.shiftTypes.filter(function (type) {
                    return hasAnyShift ? !type.is_first_day : !!type.is_first_day;
                });
            }

            return vm.getOtherShiftTypes();
        };

        // Popup de exportación (modals/_popup.twig): elige qué hoja descargar.
        vm.exportPopupOpen = false;

        vm.openExportPopup = function () {
            vm.exportPopupOpen = true;
        };

        vm.closeExportPopup = function () {
            vm.exportPopupOpen = false;
        };

        // sheet: 'calendar' (Calendario) | 'overtime' (Resumen de horas extras).
        vm.exportExcel = function (sheet) {

            vm.closeExportPopup();

            var params = [
                'sheet=' + encodeURIComponent(sheet),
                'month=' + encodeURIComponent(vm.filters.month),
                'year=' + encodeURIComponent(vm.filters.year)
            ];

            if (vm.filters.departments.length) {
                params.push('department=' + encodeURIComponent(vm.filters.departments.join(',')));
            }

            if (vm.filters.shiftType) {
                params.push('shiftType=' + encodeURIComponent(vm.filters.shiftType));
            }

            if (vm.filters.search) {
                params.push('search=' + encodeURIComponent(vm.filters.search));
            }

            if (vm.filters.groupByDistinguisher) {
                params.push('groupBy=distinguisher');
            }

            if (vm.filters.distinguishers.length) {
                params.push('distinguisher=' + encodeURIComponent(vm.filters.distinguishers.join(',')));
            }

            window.location.href = '/backend/shifts/export-excel?' + params.join('&');
        };

        vm.importingExcel = false;

        // Abre el selector de ficheros; el Excel se importa en el mes que se
        // está viendo. Se crea el input al vuelo porque ng-change no funciona
        // con input[type=file].
        vm.openImportExcel = function () {

            if (vm.importingExcel) {
                return;
            }

            var input = document.createElement('input');

            input.type = 'file';
            input.accept = '.xlsx,.xls,.csv';
            input.onchange = function () {

                var file = input.files && input.files[0];

                if (file) {
                    $scope.$apply(function () {
                        vm.importExcel(file);
                    });
                }
            };

            input.click();
        };

        vm.importExcel = function (file) {

            vm.importingExcel = true;

            return ShiftsService.ImportExcel(file, vm.filters.month, vm.filters.year).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.showSuccess(tr('Excel imported: only the hours of already defined shifts have been updated. Shifts that were not defined have not been created.'));

                return vm.loadGrid();

            }).catch(function (error) {

                vm.showError(tr('Could not import the Excel file.'), error);

            }).finally(function () {

                vm.importingExcel = false;
            });
        };

        vm.generatingMonth = false;
        vm.generatePattern = {
            workDays: 4,
            restDays: 3,
            // Días de la semana (ISO: 1 = lunes ... 7 = domingo) que cuentan para el patrón.
            // Los desmarcados no avanzan el ciclo y se generan como Descanso.
            weekDays: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true }
        };

        // Convierte una lista de días ISO en el mapa { iso: true } que usan los
        // botones. Sin lista (patrones antiguos), cuentan todos los días.
        vm.buildPatternWeekDaysMap = function (weekDays) {

            var map = {};

            for (var iso = 1; iso <= 7; iso++) {
                map[iso] = !weekDays || !weekDays.length || weekDays.indexOf(iso) !== -1;
            }

            return map;
        };

        vm.patternWeekDays = [
            { iso: 1, label: tr('Mo'), name: tr('Monday') },
            { iso: 2, label: tr('Tu'), name: tr('Tuesday') },
            { iso: 3, label: tr('We'), name: tr('Wednesday') },
            { iso: 4, label: tr('Th'), name: tr('Thursday') },
            { iso: 5, label: tr('Fr'), name: tr('Friday') },
            { iso: 6, label: tr('Sa'), name: tr('Saturday') },
            { iso: 7, label: tr('Su'), name: tr('Sunday') }
        ];

        vm.togglePatternWeekDay = function (pattern, iso, errorKey) {
            pattern.weekDays[iso] = !pattern.weekDays[iso];
            vm.clearFieldError(errorKey);
        };

        vm.getSelectedPatternWeekDays = function (pattern) {
            return vm.patternWeekDays.filter(function (weekDay) {
                return pattern.weekDays[weekDay.iso];
            }).map(function (weekDay) {
                return weekDay.iso;
            });
        };

        vm.generateMonth = function () {

            var errors = {};

            if (!vm.isValidPatternDays(vm.generatePattern.workDays)) {
                errors['generatePattern.workDays'] = true;
            }

            if (!vm.isValidPatternDays(vm.generatePattern.restDays)) {
                errors['generatePattern.restDays'] = true;
            }

            if (!vm.setFieldErrors(errors)) {
                vm.fieldErrors['generatePattern'] = tr('The pattern work and rest days must be at least 1.');
                return;
            }

            var weekDays = vm.getSelectedPatternWeekDays(vm.generatePattern);

            if (!weekDays.length) {
                vm.fieldErrors['generatePattern'] = tr('Select at least one weekday for the pattern.');
                return;
            }

            var workDays = Number(vm.generatePattern.workDays);
            var restDays = Number(vm.generatePattern.restDays);

            // if (!confirm('¿Rellenar todos los días sin turno de ' + vm.monthNames[vm.filters.month - 1] + ' ' + vm.filters.year + ' con el patrón ' + workDays + ' días de trabajo / ' + restDays + ' de descanso? El patrón propio de cada persona (si lo tiene definido) tendrá prioridad sobre este.')) {
            //     return;
            // }

            vm.generatingMonth = true;

            var payload = {
                month: vm.filters.month,
                year: vm.filters.year,
                workDays: workDays,
                restDays: restDays,
                weekDays: weekDays
            };

            if (vm.filters.departments.length) {
                payload.department = vm.filters.departments.slice();
            }

            if (vm.filters.search) {
                payload.search = vm.filters.search;
            }

            return ShiftsService.GenerateMonth(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                return vm.loadGrid();

            }).catch(function (error) {

                vm.showError(tr('Could not generate the month.'), error);

            }).finally(function () {

                vm.generatingMonth = false;
            });
        };

        vm.deletingMonth = false;

        vm.deleteMonth = function () {

            vm.askConfirm({
                title: tr('Delete month shifts'),
                message: tr('Are you sure you want to DELETE all shifts of {month} {year}? This action cannot be undone.', {
                    month: vm.monthNames[vm.filters.month - 1],
                    year: vm.filters.year
                }),
                confirmLabel: tr('Delete shifts'),
                onConfirm: vm.executeDeleteMonth
            });
        };

        vm.executeDeleteMonth = function () {

            vm.deletingMonth = true;

            var payload = {
                month: vm.filters.month,
                year: vm.filters.year
            };

            if (vm.filters.departments.length) {
                payload.department = vm.filters.departments.slice();
            }

            if (vm.filters.search) {
                payload.search = vm.filters.search;
            }

            return ShiftsService.DeleteMonth(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                return vm.loadGrid();

            }).catch(function (error) {

                vm.showError(tr('Could not delete the month shifts.'), error);

            }).finally(function () {

                vm.deletingMonth = false;
            });
        };

        vm.isVacationModalOpen = false;
        vm.vacationModalLoading = false;
        vm.vacationTargetYear = null;
        vm.vacationSelectedDates = {};
        vm.vacationMonths = [];
        vm.applyingVacations = false;
        vm.importingVacationsFromSap = false;

        vm.openVacationModal = function () {

            vm.isVacationModalOpen = true;
            vm.vacationSelectedDates = {};
            vm.clearFieldError('vacationDates');

            // El calendario se construye ya mismo para el año actual, sin
            // esperar a la respuesta del servidor: así el modal se abre
            // siempre con un calendario funcional (aunque no haya ningún
            // festivo guardado todavía, o aunque falle la carga) y se puede
            // marcar días nuevos con normalidad.
            vm.vacationTargetYear = new Date().getFullYear();
            vm.vacationMonths = vm.buildVacationMonths(vm.vacationTargetYear);

            vm.loadVacationDays();
        };

        vm.closeVacationModal = function () {
            vm.isVacationModalOpen = false;
        };

        // Festivos guardados localmente (tipo de contenido "holidays") para
        // el año actual. Para traer días nuevos de SAP está vm.importVacationsFromSap.
        // Si esto falla (por ejemplo por no haber ningún festivo guardado
        // todavía) no se cierra ni se bloquea el modal: el calendario en
        // blanco ya construido en openVacationModal sigue siendo utilizable.
        vm.loadVacationDays = function () {

            vm.vacationModalLoading = true;

            return ShiftsService.GetVacationDays().then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.vacationTargetYear = data.targetYear;

                var selected = {};

                (data.dates || []).forEach(function (dateStr) {
                    selected[dateStr] = true;
                });

                vm.vacationSelectedDates = selected;
                vm.vacationMonths = vm.buildVacationMonths(data.targetYear);

            }).catch(function (error) {

                vm.showError(tr('Could not get the saved holidays. A blank calendar is shown.'), error);

            }).finally(function () {

                vm.vacationModalLoading = false;
            });
        };

        // Recoge de SAP las vacaciones/festivos del último año definido y las
        // guarda como nuevos "holidays" locales (sin duplicar los ya guardados),
        // y recarga el modal para reflejar los días recién guardados.
        vm.importVacationsFromSap = function () {

            // if (!confirm('¿Recoger de SAP las vacaciones/festivos del último año definido y guardarlas como festivos de la empresa? Los días ya guardados no se duplican.')) {
            //     return;
            // }

            vm.importingVacationsFromSap = true;

            return ShiftsService.ImportVacationsFromSap().then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.showSuccess(tr('SAP holidays ({sourceYear}) saved for {targetYear}: {created} new ({skipped} already existed).', {
                    sourceYear: data.sourceYear,
                    targetYear: data.targetYear,
                    created: data.created,
                    skipped: data.skipped
                }));

                return vm.loadVacationDays();

            }).catch(function (error) {

                vm.showError(tr('Could not import the vacations from SAP.'), error);

            }).finally(function () {

                vm.importingVacationsFromSap = false;
            });
        };

        vm.buildVacationMonths = function (year) {

            var months = [];

            for (var m = 0; m < 12; m++) {

                var daysInMonth = new Date(year, m + 1, 0).getDate();
                var firstDay = new Date(year, m, 1).getDay();
                var mondayFirstIndex = (firstDay + 6) % 7;

                var cells = [];

                for (var b = 0; b < mondayFirstIndex; b++) {
                    cells.push(null);
                }

                for (var d = 1; d <= daysInMonth; d++) {
                    cells.push({
                        day: d,
                        date: year + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0')
                    });
                }

                months.push({
                    name: vm.monthNames[m],
                    cells: cells
                });
            }

            return months;
        };

        vm.toggleVacationDay = function (dateStr) {

            if (vm.vacationSelectedDates[dateStr]) {
                delete vm.vacationSelectedDates[dateStr];
            } else {
                vm.vacationSelectedDates[dateStr] = true;
            }

            vm.clearFieldError('vacationDates');
        };

        vm.getVacationSelectedCount = function () {
            return Object.keys(vm.vacationSelectedDates).length;
        };

        // "Aceptar vacaciones": hace lo mismo que hacía antes, en dos pasos
        // encadenados: primero guarda los días marcados como "holidays"
        // (vm.defineVacations) y después los aplica como Descanso al
        // personal activo (vm.applyVacations).
        vm.confirmVacations = function () {

            var dates = Object.keys(vm.vacationSelectedDates);

            if (!dates.length) {
                vm.fieldErrors['vacationDates'] = tr('You have not selected any day.');
                return;
            }

            vm.applyingVacations = true;

            return ShiftsService.DefineVacations({ dates: dates, year: vm.vacationTargetYear }).then(function (defineData) {

                if (!defineData || !defineData.success) {
                    return $q.reject(defineData);
                }

                return ShiftsService.ApplyVacations({ dates: dates });

            }).then(function (applyData) {

                if (!applyData || !applyData.success) {
                    return $q.reject(applyData);
                }

                vm.closeVacationModal();

                return vm.loadGrid();

            }).catch(function (error) {

                vm.showError(tr('Could not apply the vacations.'), error);

            }).finally(function () {

                vm.applyingVacations = false;
            });
        };

        vm.isWorkerModalOpen = false;
        vm.workerModalRow = null;
        vm.workerModalMonth = null;
        vm.workerModalYear = null;
        vm.workerModalDays = [];
        vm.workerModalDaysInMonth = 0;
        vm.workerModalLoading = false;
        vm.workerModalSelectedDay = null;
        vm.workerModalPattern = { workDays: 4, restDays: 3, weekDays: vm.buildPatternWeekDaysMap(null) };
        vm.generatingWorkerMonth = false;
        vm.deletingWorkerMonth = false;

        vm.getWorkerModalDefaultDay = function () {

            var now = new Date();

            if (vm.workerModalMonth === (now.getMonth() + 1) && vm.workerModalYear === now.getFullYear()) {
                return now.getDate();
            }

            return 1;
        };

        // Seleccionar un día en el calendario individual también prepara, en el
        // mismo estado que usa el editor general, las acciones de asignación de
        // turno que se muestran embebidas en la columna lateral (no en un modal).
        vm.selectWorkerModalDay = function (day) {

            vm.workerModalSelectedDay = day;
            vm.isLineDropdownOpen = false;
            vm.isSupervisorDropdownOpen = false;
            vm.workdayEditor.open = false;

            vm.editorRow = vm.workerModalRow;
            vm.editorDay = day;
            vm.editorMonth = vm.workerModalMonth;
            vm.editorYear = vm.workerModalYear;
            vm.editorContext = 'personal';
            vm.pendingShiftType = null;
            vm.pendingReasonShiftType = null;
            vm.pendingReason = '';
            vm.pendingReasonInfo = '';
            vm.pendingRangeStart = vm.getEditorDayDate(day);
            vm.pendingRangeEnd = vm.getEditorDayDate(day);
            vm.clearFieldError('pendingNextShiftType');
            vm.clearFieldError('pendingReason');
            vm.clearFieldError('pendingRangeStart');
            vm.clearFieldError('pendingRangeEnd');
        };

        vm.getWorkerModalSelectedShift = function () {

            if (!vm.workerModalRow || !vm.workerModalSelectedDay) {
                return null;
            }

            return vm.workerModalRow.shifts[vm.workerModalSelectedDay] || null;
        };

        // Si el turno del día seleccionado es de un tipo con horas (T1, T2...)
        // o "Primer día" (que recoge las de Turno 1 o 2): solo entonces tienen
        // sentido supervisor, jornada y lugar de trabajo.
        vm.isWorkerModalSelectedHourShift = function () {

            var shift = vm.getWorkerModalSelectedShift();

            if (!shift) {
                return false;
            }

            var shiftType = (vm.shiftTypes || []).find(function (type) {
                return String(type.id) === String(shift.shiftTypeId);
            });

            return vm.isHourCode(shiftType) || !!(shiftType && shiftType.is_first_day);
        };

        vm.isLineDropdownOpen = false;

        vm.toggleLineDropdown = function () {

            if (!vm.getWorkerModalSelectedShift()) {
                return;
            }

            vm.isLineDropdownOpen = !vm.isLineDropdownOpen;
        };

        vm.selectLine = function (line) {

            var shift = vm.getWorkerModalSelectedShift();

            vm.isLineDropdownOpen = false;

            if (!shift || !vm.workerModalRow || !vm.workerModalSelectedDay || line.id === shift.currentLineId) {
                return;
            }

            var dayDate = new Date(vm.workerModalYear, vm.workerModalMonth - 1, vm.workerModalSelectedDay);
            var dayString = dayDate.getFullYear() + '-' +
                String(dayDate.getMonth() + 1).padStart(2, '0') + '-' +
                String(dayDate.getDate()).padStart(2, '0');

            var payload = {
                personal: vm.workerModalRow.id,
                day: dayString,
                line: line.id
            };

            return ShiftsService.UpdateShiftLine(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                shift.currentLineId = line.id;
                shift.currentLine = data.currentLine ? data.currentLine.name : line.name;
                vm.decorateCell(shift);

            }).catch(function (error) {

                vm.showError(tr('Could not update the shift line.'), error);
            });
        };

        // El supervisor es una propiedad de la persona, no del turno de un día
        // concreto: se guarda directamente en Personal.responsable_id.
        vm.isSupervisorDropdownOpen = false;

        vm.toggleSupervisorDropdown = function () {
            vm.isSupervisorDropdownOpen = !vm.isSupervisorDropdownOpen;
        };

        vm.selectSupervisor = function (person) {

            vm.isSupervisorDropdownOpen = false;

            if (!vm.workerModalRow || person.id === vm.workerModalRow.supervisorId) {
                return;
            }

            var payload = {
                personal: vm.workerModalRow.id,
                supervisor: person.id
            };

            var row = vm.workerModalRow;

            return ShiftsService.UpdateSupervisor(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                row.supervisorId = person.id;
                row.supervisor = data.supervisor ? data.supervisor.name : person.name;

            }).catch(function (error) {

                vm.showError(tr('Could not update the supervisor.'), error);
            });
        };

        // Distintivo de calendario: propiedad de la persona (Personal.distinguisher)
        // que colorea su celda de nombre en el calendario general.
        vm.distinguishers = [];
        vm.isDistinguisherDropdownOpen = false;

        // Departamento cuya lista de áreas está cargada en vm.distinguishers.
        // El modal individual se recarga tras cada acción (cambio de mes,
        // generar, borrar...), pero la lista solo depende del departamento:
        // si no ha cambiado, no se vuelve a pedir.
        var loadedDistinguishersDepartment;

        vm.loadDistinguishers = function (departmentId) {

            var departmentKey = String(departmentId || '');

            if (departmentKey === loadedDistinguishersDepartment) {
                return $q.resolve();
            }

            loadedDistinguishersDepartment = departmentKey;

            var params = {};

            if (departmentId) {
                params.department = departmentId;
            }

            return ShiftsService.GetDistinguishers(params).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.distinguishers = data.distinguishers || [];

            }).catch(function (error) {

                // Si falla, se permite reintentar en la siguiente recarga.
                loadedDistinguishersDepartment = undefined;

                vm.showError(tr('Could not get the areas.'), error);
            });
        };

        vm.toggleDistinguisherDropdown = function () {
            vm.isDistinguisherDropdownOpen = !vm.isDistinguisherDropdownOpen;
        };

        // distinguisher = null quita el distintivo de la persona.
        vm.selectDistinguisher = function (distinguisher) {

            vm.isDistinguisherDropdownOpen = false;

            if (!vm.workerModalRow) {
                return;
            }

            var currentId = vm.workerModalRow.distinguisher ? vm.workerModalRow.distinguisher.id : null;
            var newId = distinguisher ? distinguisher.id : null;

            if (String(currentId) === String(newId)) {
                return;
            }

            var row = vm.workerModalRow;

            return ShiftsService.UpdateDistinguisher({
                personal: row.id,
                distinguisher: newId
            }).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                row.distinguisher = data.distinguisher || null;

            }).catch(function (error) {

                vm.showError(tr('Could not update the area.'), error);
            });
        };

        // Fondo de las celdas de nombre, DNI y departamento con el color del
        // distintivo (tintado sobre blanco para que siga siendo opaco en las
        // columnas fijas). Con withStripe, además, una franja a la izquierda
        // con el color puro (solo en la celda del nombre).
        vm.getDistinguisherCellStyle = function (row, withStripe) {

            var color = row && row.distinguisher ? row.distinguisher.color : null;

            if (!color) {
                return {};
            }

            var style = {
                'background': 'linear-gradient(' + color + '40, ' + color + '40), #fff'
            };

            if (withStripe) {
                style['box-shadow'] = 'inset 4px 0 0 ' + color;
            }

            return style;
        };

        vm.formatShiftTime = function (date) {
            if (!date) {
                return '-';
            }

            // La jornada editada se guarda como "HH:MM".
            var match = /^(\d{1,2}):(\d{2})/.exec(String(date));

            if (match) {
                return match[1].padStart(2, '0') + ':' + match[2];
            }

            var d = new Date(date);

            if (isNaN(d.getTime())) {
                return '-';
            }

            return String(d.getUTCHours()).padStart(2, '0') + ':' +
                String(d.getUTCMinutes()).padStart(2, '0');
        };

        // Si el turno tiene inicio/fin guardados (start_shift / end_shift) se
        // usan esos. Si no, se usa la jornada por defecto del tipo de turno
        // (su start_shift / end_shift) que manda el backend en "workday".
        vm.getShiftWorkdayTimes = function (shift) {

            if (!shift) {
                return null;
            }

            if (shift.workday && !shift.startShift && !shift.endShift) {
                return { start: shift.workday.start, end: shift.workday.end };
            }

            return {
                start: vm.formatShiftTime(shift.startShift),
                end: vm.formatShiftTime(shift.endShift)
            };
        };

        vm.getShiftWorkdayLabel = function (shift) {

            var times = vm.getShiftWorkdayTimes(shift);

            return times ? times.start + ' - ' + times.end : '-';
        };

        // Texto al pasar el ratón por un turno:
        //  - con horas (Turno 1, Turno 2, Primer día...): tipo, su jornada real
        //    (la guardada en el turno o, si no, la de su tipo) y la línea;
        //  - sin horas (Descanso, Vacaciones...): tipo y, si lo tiene, el
        //    motivo. La línea no se muestra aunque el turno la conserve de
        //    cuando era de otro tipo.
        vm.getShiftTooltip = function (shift) {

            if (!shift) {
                return tr('No shift');
            }

            var text = shift.name || tr('No shift');

            if (!(Number(shift.workedHours) > 0)) {
                return shift.incidence ? text + ': ' + shift.incidence : text;
            }

            text += ' (' + vm.getShiftWorkdayLabel(shift) + ')';

            if (shift.currentLine) {
                text += ' · ' + tr('Line: {line}', { line: shift.currentLine });
            }

            return text;
        };

        vm.noShiftTooltip = tr('No shift');

        // Guarda en la celda su estilo y su texto al pasar el ratón ($style,
        // $tooltip) para que la rejilla no los recalcule en cada ciclo de
        // render. Hay que volver a llamarla cada vez que cambie la celda.
        vm.decorateCell = function (cell) {

            if (cell) {
                cell.$style = vm.getCellStyle({ shifts: { 0: cell } }, 0);
                cell.$tooltip = vm.getShiftTooltip(cell);
            }

            return cell;
        };

        vm.decorateRowCells = function (row) {
            angular.forEach(row.shifts || {}, vm.decorateCell);
        };

        // Editor de la jornada laboral del día seleccionado en el calendario
        // individual (horas y minutos de inicio y fin).
        vm.workdayEditor = {
            open: false,
            start: { hours: null, minutes: null },
            end: { hours: null, minutes: null }
        };

        // "HH:MM" => { hours, minutes }; cualquier otra cosa (p.ej. '-') queda vacía.
        vm.parseWorkdayTime = function (value) {

            var match = /^(\d{1,2}):(\d{2})$/.exec(value || '');

            if (!match) {
                return { hours: null, minutes: null };
            }

            return { hours: Number(match[1]), minutes: Number(match[2]) };
        };

        vm.openWorkdayEditor = function () {

            var times = vm.getShiftWorkdayTimes(vm.getWorkerModalSelectedShift());

            vm.clearFieldError('workdayEditor');

            vm.workdayEditor = {
                open: true,
                start: vm.parseWorkdayTime(times ? times.start : null),
                end: vm.parseWorkdayTime(times ? times.end : null)
            };
        };

        vm.closeWorkdayEditor = function () {
            vm.workdayEditor.open = false;
            vm.clearFieldError('workdayEditor');
        };

        vm.isValidTimePart = function (value, max) {
            var number = Number(value);

            return value !== null && value !== undefined && value !== '' &&
                Math.floor(number) === number && number >= 0 && number <= max;
        };

        vm.formatTimeParts = function (time) {
            return String(time.hours).padStart(2, '0') + ':' + String(time.minutes).padStart(2, '0');
        };

        // Guarda el inicio y fin de la jornada en start_shift / end_shift del
        // turno; el backend recalcula a partir de ellos las horas del turno (time).
        vm.saveWorkdayEditor = function () {

            var shift = vm.getWorkerModalSelectedShift();
            var editor = vm.workdayEditor;

            if (!shift || !vm.workerModalRow || !vm.workerModalSelectedDay) {
                return;
            }

            if (
                !vm.isValidTimePart(editor.start.hours, 23) || !vm.isValidTimePart(editor.start.minutes, 59) ||
                !vm.isValidTimePart(editor.end.hours, 23) || !vm.isValidTimePart(editor.end.minutes, 59)
            ) {
                vm.fieldErrors['workdayEditor'] = tr('Enter hours between 0 and 23 and minutes between 0 and 59.');
                return;
            }

            var dayDate = new Date(vm.workerModalYear, vm.workerModalMonth - 1, vm.workerModalSelectedDay);
            var dayString = dayDate.getFullYear() + '-' +
                String(dayDate.getMonth() + 1).padStart(2, '0') + '-' +
                String(dayDate.getDate()).padStart(2, '0');

            var payload = {
                personal: vm.workerModalRow.id,
                day: dayString,
                start: vm.formatTimeParts(editor.start),
                end: vm.formatTimeParts(editor.end)
            };

            return ShiftsService.UpdateShiftWorkday(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                shift.startShift = data.startShift;
                shift.endShift = data.endShift;
                shift.hours = data.hours;
                shift.workedHours = data.workedHours;
                shift.display = data.display;
                vm.decorateCell(shift);

                vm.workerModalRow.hours = vm.recalculateRowHours(vm.workerModalRow, vm.workerModalDays);

                vm.closeWorkdayEditor();

            }).catch(function (error) {

                vm.showError(tr('Could not update the shift working hours.'), error);
            });
        };


        vm.getWorkerModalSelectedDateLabel = function () {

            if (!vm.workerModalSelectedDay || !vm.workerModalMonth || !vm.workerModalYear) {
                return '';
            }

            var weekdays = [tr('Sunday'), tr('Monday'), tr('Tuesday'), tr('Wednesday'), tr('Thursday'), tr('Friday'), tr('Saturday')];
            var date = new Date(vm.workerModalYear, vm.workerModalMonth - 1, vm.workerModalSelectedDay);

            return tr('{weekday} {day} of {month}', {
                weekday: weekdays[date.getDay()],
                day: vm.workerModalSelectedDay,
                month: vm.monthNames[vm.workerModalMonth - 1]
            });
        };

        vm.openWorkerModal = function (row) {

            vm.workerModalRow = row;
            vm.workerModalMonth = vm.filters.month;
            vm.workerModalYear = vm.filters.year;
            vm.workerModalSelectedDay = vm.getWorkerModalDefaultDay();
            vm.isWorkerModalOpen = true;
            vm.isSupervisorDropdownOpen = false;
            vm.isDistinguisherDropdownOpen = false;
            vm.resetFieldErrors();

            vm.loadWorkerModal();
        };

        vm.closeWorkerModal = function () {

            vm.isWorkerModalOpen = false;
            vm.workerModalRow = null;
            vm.resetFieldErrors();

            vm.loadGrid();
        };

        vm.loadWorkerModal = function () {

            vm.workerModalLoading = true;

            return ShiftsService.GetEmployeeShifts({
                personal: vm.workerModalRow.id,
                month: vm.workerModalMonth,
                year: vm.workerModalYear
            }).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.workerModalRow = data.row;
                vm.decorateRowCells(vm.workerModalRow);
                vm.workerModalDaysInMonth = data.daysInMonth;
                vm.loadDistinguishers(data.row.departmentId);
                vm.workerModalDays = vm.buildDaysArray(data.daysInMonth);

                vm.workerModalPattern = data.row.pattern
                    ? { workDays: data.row.pattern.workDays, restDays: data.row.pattern.restDays, weekDays: vm.buildPatternWeekDaysMap(data.row.pattern.weekDays) }
                    : { workDays: 4, restDays: 3, weekDays: vm.buildPatternWeekDaysMap(null) };

                // Reengancha el editor lateral al objeto de fila recién cargado
                // (el anterior queda obsoleto tras cada recarga del modal).
                vm.selectWorkerModalDay(vm.workerModalSelectedDay || vm.getWorkerModalDefaultDay());

            }).catch(function (error) {

                vm.showError(tr('Could not get the worker calendar.'), error);

            }).finally(function () {

                vm.workerModalLoading = false;
            });
        };

        vm.changeWorkerModalMonth = function (delta) {

            var date = new Date(vm.workerModalYear, vm.workerModalMonth - 1 + delta, 1);

            vm.workerModalMonth = date.getMonth() + 1;
            vm.workerModalYear = date.getFullYear();
            vm.workerModalSelectedDay = vm.getWorkerModalDefaultDay();

            vm.loadWorkerModal();
        };

        vm.generateWorkerMonth = function () {

            var errors = {};

            if (!vm.isValidPatternDays(vm.workerModalPattern.workDays)) {
                errors['workerModalPattern.workDays'] = true;
            }

            if (!vm.isValidPatternDays(vm.workerModalPattern.restDays)) {
                errors['workerModalPattern.restDays'] = true;
            }

            if (!vm.setFieldErrors(errors)) {
                vm.fieldErrors['workerModalPattern'] = tr('The pattern work and rest days must be at least 1.');
                return;
            }

            var weekDays = vm.getSelectedPatternWeekDays(vm.workerModalPattern);

            if (!weekDays.length) {
                vm.fieldErrors['workerModalPattern'] = tr('Select at least one weekday for the pattern.');
                return;
            }

            var workDays = Number(vm.workerModalPattern.workDays);
            var restDays = Number(vm.workerModalPattern.restDays);

            // if (!confirm('¿Generar el calendario de ' + vm.workerModalRow.name + ' ' + vm.workerModalRow.surname + ' para ' + vm.monthNames[vm.workerModalMonth - 1] + ' ' + vm.workerModalYear + ' con el patrón ' + workDays + ' días de trabajo / ' + restDays + ' de descanso? Este patrón quedará guardado como el patrón propio de esta persona.')) {
            //     return;
            // }

            vm.generatingWorkerMonth = true;

            var payload = {
                month: vm.workerModalMonth,
                year: vm.workerModalYear,
                personal: vm.workerModalRow.id,
                workDays: workDays,
                restDays: restDays,
                weekDays: weekDays
            };

            return ShiftsService.GenerateMonth(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                return vm.loadWorkerModal();

            }).catch(function (error) {

                vm.showError(tr('Could not generate the worker calendar.'), error);

            }).finally(function () {

                vm.generatingWorkerMonth = false;
            });
        };

        vm.deleteWorkerMonth = function () {

            vm.askConfirm({
                title: tr('Delete calendar'),
                message: tr('Are you sure you want to DELETE all shifts of {worker} in {month} {year}? This action cannot be undone.', {
                    worker: vm.workerModalRow.name + ' ' + vm.workerModalRow.surname,
                    month: vm.monthNames[vm.workerModalMonth - 1],
                    year: vm.workerModalYear
                }),
                confirmLabel: tr('Delete calendar'),
                onConfirm: vm.executeDeleteWorkerMonth
            });
        };

        vm.executeDeleteWorkerMonth = function () {

            if (!vm.workerModalRow) {
                return;
            }

            vm.deletingWorkerMonth = true;

            var payload = {
                month: vm.workerModalMonth,
                year: vm.workerModalYear,
                personal: vm.workerModalRow.id
            };

            return ShiftsService.DeleteMonth(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                return vm.loadWorkerModal();

            }).catch(function (error) {

                vm.showError(tr('Could not delete the worker calendar.'), error);

            }).finally(function () {

                vm.deletingWorkerMonth = false;
            });
        };

        vm.getWorkerModalLeadingBlanks = function () {

            if (!vm.workerModalMonth || !vm.workerModalYear) {
                return [];
            }

            var firstDay = new Date(vm.workerModalYear, vm.workerModalMonth - 1, 1).getDay();
            var mondayFirstIndex = (firstDay + 6) % 7;

            var blanks = [];

            for (var i = 0; i < mondayFirstIndex; i++) {
                blanks.push(i);
            }

            return blanks;
        };

        vm.isWorkerModalToday = function (day) {

            var now = new Date();

            return day === now.getDate() &&
                vm.workerModalMonth === (now.getMonth() + 1) &&
                vm.workerModalYear === now.getFullYear();
        };

        vm.init();
    }
})();
